import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserEditForm from "../components/UserEditForm";
import { selectAuth, updateRequested } from "../slice";
import { useNavigate } from "react-router-dom";

export default function UserEditContainer() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { updateStatus, updateError } = useSelector(selectAuth);

  const [me, setMe] = useState(null);

  useEffect(() => {
    // 원본 HTML과 동일: localStorage.user로 초기화
    try {
      const u = localStorage.getItem("user");
      setMe(u ? JSON.parse(u) : null);
    } catch {
      setMe(null);
    }
  }, []);

  useEffect(() => {
    if (updateStatus === "succeeded") {
      const lang = (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
      alert(lang === "zh-CN" ? "修改已成功。" : "수정 완료되었습니다.");
      nav("/profiling");
    }
  }, [updateStatus, nav]);

  if (!me) return <p>회원 정보를 불러오는 중…</p>;

  return (
    <div className="editfield">
      <UserEditForm
        user={me}
        loading={updateStatus === "loading"}
        error={updateError}
        onSubmit={(payload) => dispatch(updateRequested(payload))}
      />
    </div>
  );
}
